import type { DtdLocale } from "@/locales/fr/dtd";

import { EDtdResponse } from "@/types/backoffice/dto/dtd/dtd-response-dto.ts";

const dtdLocale: DtdLocale = {
  dtd: {
    pageTitle: "DTD",
    title: "DTD: Discomfort Temperature Diagnosis",
    concernedRoom: "The concerned room",
    inconfortTime: "Time of the inconfort",
    inconfortType: "Type of inconfort",
    hot: "Hot",
    cold: "Cold",
    analyse: "Analyse",
    proposedActions: "Proposed actions",
    beforeDiagnosis: "Before performing a diagnosis :",
    askTemperature: "Ask for the set temperature on the screen (or dial number)",
    checkRadiator: 'Check that the radiator is in "External Programming" mode',
    dtdAnalysis: "DTD ANALYSIS",
    analysis: {
      [EDtdResponse.SITE_NOT_VX]:
        "The site selected is equipped with an older range (v2-v5). Analysis is not possible.",
      [EDtdResponse.HAVE_GE]:
        "An external Energy Manager (not Voltalis) has been detected.\n" +
        "\n" +
        "As a reminder, an external energy manager is a thermostat (connected or not), a programmer or a regulator that controls radiators (excluding the Voltalis solution).",
      [EDtdResponse.HAVE_PAC]: " Temperature control for a heat pump requires a temperature sensor. ",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK]:
        "Collecting data from the third-party sensor does not enable remote control to be validated.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK]:
        "Collecting data from the third-party sensor does not enable remote control to be validated.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK]:
        " The collection of consumption data did not allow remote control to be validated, so the system switched to a less efficient back-up control mode during this period.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK]:
        " The collection of consumption data did not allow remote control to be validated, so the system switched to a less efficient back-up control mode during this period.",
      [EDtdResponse.RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL]:
        "The module is connected to our platform but is unable to control your device.",
      [EDtdResponse.NO_CONSUMPTION_FOUND]:
        " Consumption is too low to generate heat. The discomfort is not linked to the radiator fitted with the Voltalis solution.",
      [EDtdResponse.NO_TEMPERATURE_CONTROL]: " The member has not used the Temperature mode over the given period.",
      [EDtdResponse.VERSION_IS_OUT_OF_DATE]: " The communication module is not up to date.",
      [EDtdResponse.NO_PROBLEM_FOUND]: "No anomalies detected during control using the temperature sensor. ",
      [EDtdResponse.CALIBRATION_NEEDED_HOT]:
        " Calibration is necessary. \n" + " Last member calibration: No calibration.",
      [EDtdResponse.CALIBRATION_NEEDED_COLD]:
        " Calibration could be necessary. \n" + " Last member calibration: No calibration.",
      [`${EDtdResponse.CALIBRATION_NEEDED_HOT}_WITH_PROPERTIES`]:
        " Calibration is necessary. \n" +
        " Last member calibration: {lastCalibrationTemperature}°C on {lastCalibrationDate}. ",
      [`${EDtdResponse.CALIBRATION_NEEDED_COLD}_WITH_PROPERTIES`]:
        " Calibration could be necessary. \n" +
        " Last member calibration: {lastCalibrationTemperature}°C on {lastCalibrationDate}. ",
      [EDtdResponse.IMPOSSIBLE_DIAGNOSIS]: "Diagnostic impossible.",
    },
    action: {
      [EDtdResponse.SITE_NOT_VX]: "",
      [EDtdResponse.HAVE_GE]: "Please ask the member to deactivate it or set it to comfort (or sun).",
      [EDtdResponse.HAVE_PAC]: "Please request a third-party sensor for this site.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK]:
        " Communication has since been re-established. Ask whether the member is still experiencing discomfort and, if so, restart the DTD diag with a more recent period.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK]:
        "Check that the third-party sensor is communicating correctly. If no problem is identified, escalate this site to ‘Technical assistance - Non urgent’, specifying: #DTD, the part concerned, the ACQ_CT code.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK]:
        "Communication has since been re-established. Ask whether the member is still experiencing discomfort, and if so, re-launch the DTD diag with a more recent period.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK]:
        " Check that the system is properly communicated.",
      [EDtdResponse.RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL]:
        " Invite the member to set their radiator to ‘External Programming’ and carry out a ‘Diagnosis’ in a VoltaCall",
      [EDtdResponse.NO_CONSUMPTION_FOUND]:
        "Ask members to check other sources of heat: underfloor heating, wood-burning stoves, fireplaces, exposure to the sun, etc.",
      [EDtdResponse.NO_TEMPERATURE_CONTROL]:
        "Select a different period. Otherwise, invite the member to use the temperature mode and return to Assistance if they are uncomfortable.",
      [EDtdResponse.VERSION_IS_OUT_OF_DATE]: "Climb to level 2.",
      [EDtdResponse.NO_PROBLEM_FOUND]:
        "Level 1: \n" +
        "Check with the member that the third-party sensor complies with the installation instructions: in the radiator room, unobstructed at ground level, not exposed to the sun.\n" +
        "Ask for the comfort temperature or the level of the setpoint knob or the knob directly on the radiator: \n" +
        "If below 15°C or knob <2 ? The discomfort is not related to Voltalis. Ask the user to increase the comfort temperature. \n" +
        "If not, escalate to N2 assistance.\n" +
        "Level 2: escalate the case to the design department, specifying the room concerned, the date of the discomfort and the type of discomfort.",
      [EDtdResponse.CALIBRATION_NEEDED_HOT]:
        "Level 1: Calibrate if the member has not calibrated or has calibrated before the discomfort. If not, escalate to N2 assistance.\n" +
        "Level 2: escalate the case to the design department, specifying the room concerned, the date of the problem and the type of problem.",
      [EDtdResponse.CALIBRATION_NEEDED_COLD]:
        "Niveau 1: Demander la température de confort ou niveau de la mollette consigne ou la molette directement sur le radiateur.\n" +
        "Inférieure à 15 °C ou mollette <2 ? → Inconfort non lié à Voltalis et inviter à augmenter la température de confort.\n" +
        "Si non, réaliser la calibration si l’adhérent n’a pas calibré ou a calibré avant l’inconfort. \n" +
        "Si non, escalader le dossier à l’assistance N2.\n" +
        "Niveau 2: escalader le dossier au services études en précisant la pièce concernée, la date de l’inconfort ainsi que le type d’inconfort.\n" +
        "Translated with DeepL.com (free version)",
      [EDtdResponse.IMPOSSIBLE_DIAGNOSIS]:
        "Level 1: escalate the case to N2 assistance\n" +
        "Level 2: escalate the case to the design department, specifying the room concerned, the date of the problem and the type of problem.",
    },
    calibration: {
      noCalibrationTemperature: "No temperature found",
      noCalibrationDate: "No date has been found",
      calibrationTemperatureError: "A calibration error was found, no temperature indicated",
      calibrationDateError: "A calibration error was found, no date indicated",
    },
    error: {
      errorOccurred: "An error has occurred.",
      errorPleaseRetry: "An error has occurred. Please try again later.",
    },
  },
};

export default dtdLocale;
